import React from "react";
import appStyles from "../../../../app.module.css";
import AppConstants from "../../../classes/constants";

const ThanksPopUp = (props) => {
  return (
    <>
      <div className={appStyles.rezziModal}>
        <div className={appStyles.rezziModalOverlay}></div>
        <div className={appStyles.rezziModalContent}>
        <a href="#" className={appStyles.rezziModalClose} onClick={(e) => {
          e.preventDefault();
          props?.onClose();
        }}>x</a>
          <div
            className={`${appStyles.bgLightGrey} ${appStyles.rezziModalImageWrap}`}
          >
            <img
              src={`${AppConstants.WEBAPP_BASE_URL}/src/assets/images/rezzi-team.png`}
              alt=""
            />
          </div>
          <div className={appStyles.rezziModalBody}>
            <h2 className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}>
              Welcome Onboard
            </h2>
            <p className={appStyles.textCenter}>
              Our onboarding team will contact you shortly. In the meantime,
              please email a copy of your contract (Offer & Acceptance) to{" "}
              <a
                href={`mailto:${AppConstants.ADMIN_EMAIL}`}
                className={appStyles.colorPrimary}
              >
                {AppConstants.ADMIN_EMAIL}
              </a>
            </p>
          </div>

          <div
            className={`${appStyles.rezziModalFooter} ${appStyles.rezziThanksModalFooter}`}
          >
            <a
              href={AppConstants.CONTACT_US_URL}
              className={appStyles.buttonLink}
            >
              Send Us Your Contract
            </a>
            <a
              href={`tel:${AppConstants.PHONE_NUMBER}`}
              className={`${appStyles.telphoneLink} ${appStyles.telphonePopupLink}`}
            >
              Call Us {AppConstants.FORMATTED_PHONE_NUMBER}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default ThanksPopUp;
